import type { SelectProps } from 'core';
import { Empty, Select, Spin } from 'core';
import type { PropsWithChildren } from 'react';

export function withSpinSelect() {
  return function ({ children = null, ...props }: PropsWithChildren<SelectProps>) {
    const { loading } = props;

    return (
      <Select
        filterOption
        notFoundContent={loading ? <Spin className="mx-auto d-block" size="small" /> : <Empty />}
        {...props}
      >
        {children}
      </Select>
    );
  };
}
